import { render, staticRenderFns } from "./u-checkboxs.vue?vue&type=template&id=0556e7c6&scoped=true&"
import script from "./u-checkboxs.vue?vue&type=script&lang=js&"
export * from "./u-checkboxs.vue?vue&type=script&lang=js&"
import style0 from "./u-checkboxs.vue?vue&type=style&index=0&id=0556e7c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0556e7c6",
  null
  
)

export default component.exports